import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Building2, HeartPulse, ArrowLeft } from "lucide-react";
const hospitals = [{
  name: "המרכז הרפואי אסותא אשדוד",
  description: "בית חולים ציבורי מתקדם המעניק שירות רפואי מקיף לתושבי העיר.",
  icon: Building2
}, {
  name: "המרכז הרפואי ברזילי",
  description: "ממוקם באשקלון הסמוכה ומהווה עוגן רפואי משמעותי נוסף לתושבי האזור.",
  icon: HeartPulse
}];
export default function LocationsAndHospitalsInAshdod() {
  return <section id="מיקומים-וביתנות-באשדוד" className="py-16 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="space-y-8">
            <div className="space-y-4">
              <Badge variant="secondary" className="mb-2">
                שירותים רפואיים באזור
              </Badge>
              <h2 className="text-3xl md:text-4xl font-bold font-default text-primary leading-tight">
                מיקומים ובתי חולים באשדוד והסביבה
              </h2>
              <div className="space-y-4 text-lg text-muted-foreground font-default leading-relaxed">
                <p>
                  העיר אשדוד מציעה לתושביה שירותי רפואה מתקדמים ונגישים. המרכז הרפואי העיקרי בעיר הוא בית החולים הציבורי אסותא אשדוד (Ashdod Medical Center), המספק מענה רפואי מקיף, חדרי מיון, מחלקות אשפוז ומרפאות מומחים חדישות. בנוסף, תושבי אשדוד והסביבה נעזרים רבות במרכז הרפואי ברזילי (Barzilai Medical Center) הממוקם באשקלון הסמוכה, אשר מהווה עוגן רפואי משמעותי באזור הדרום.
                </p>
                <p>
                  כאשר יקירכם מאושפז באחד מבתי החולים הללו, או לקראת שחרור הביתה, הצורך בהשגחה צמודה ובטיפול סיעודי מקצועי הופך לקריטי. אנו מספקים שירותי סיעוד והשגחה פרטית בבתי החולים באשדוד ובסביבתה, וכן מטפלים סיעודיים מיומנים להמשך טיפול בבית המטופל. הצוות שלנו זמין להעניק לכם שקט נפשי וטיפול מסור, תוך התאמה מלאה לצרכים הרפואיים והאישיים.
                </p>
              </div>
            </div>

            {}
            <div className="grid sm:grid-cols-2 gap-4">
              {hospitals.map((hospital, i) => {
              const Icon = hospital.icon;
              return <div key={i} data-index={i} className="flex items-start gap-3 p-4 rounded-xl bg-muted/50 border border-border/50">
                    <div className="p-2 bg-primary/10 rounded-lg text-primary shrink-0">
                      <Icon className="w-5 h-5" />
                    </div>
                    <div>
                      <h3 className="font-semibold font-default text-foreground">
                        {hospital.name}
                      </h3>
                      <p className="text-sm text-muted-foreground mt-1 font-default">
                        {hospital.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            {}
            <div className="pt-4">
              <Button asChild size="lg" className="group">
                <Link to="/NursingCareNowPage">
                  הזמן מטפל סיעודי עכשיו
                  <ArrowLeft className="w-4 h-4 mr-2 transition-transform group-hover:-translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative lg:h-[600px] rounded-2xl overflow-hidden shadow-xl border border-border/50">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/ashdod_medical_facilities.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/ashdod_medical_facilities.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/ashdod_medical_facilities.png-wvc-sizes" alt="מרכזים רפואיים באשדוד" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/20 to-transparent pointer-events-none" />
          </div>

        </div>
      </div>
    </section>;
}